




























export default {
  name: "DpaIdDialogueAd",
  emits: ['close'],
  methods: {
    openLinkInNewTab(url: string) {
      window.open(url, "_blank");
    }
  },
}
